import React from "react";
import Grid from "@material-ui/core/Grid";

export function GridComp12({ title, data }) {
  return (
    <Grid item xs={12} sm={12} md={12} className="m-b-10">
      <p className="tFormlabel">{title}</p>
      <p className="tFormName">{data}</p>
    </Grid>
  );
}

export function GridComp6({ title, data }) {
  return (
    <Grid item xs={12} sm={6} md={6} className="m-b-10">
      <p className="tFormlabel">{title}</p>
      <p className="tFormName">{data}</p>
    </Grid>
  );
}
export function GridComp4({ title, data }) {
  return (
    <Grid item xs={12} sm={6} md={4} className="m-b-10">
      <p className="tFormlabel">{title}</p>
      <p className="tFormName">{data}</p>
    </Grid>
  );
}
export function GridComp126({ title, data }) {
  return (
    <Grid item xs={12} sm={6} className="m-b-10">
      <p className="tFormlabel">{title}</p>
      <p className="tFormName">{data}</p>
    </Grid>
  );
}
export function GridComp2({ title, data }) {
  return (
    <Grid item xs={2} sm={2} className="m-b-10">
      <p className="tFormlabel">{title}</p>
      <p className="tFormName">{data}</p>
    </Grid>
  );
}

export function GridComp12126({ title, data }) {
  return (
    <Grid item xs={12} sm={12} md={6} className="m-b-10">
      <p className="tFormlabel">{title}</p>
      <p className="tFormName">{data}</p>
    </Grid>
  );
}
